<template>
	<div>
		<CForm
			class="d-block"
			@submit.prevent="handleSubmit"
		>
			<CRow>
				<CCol md="3">
					<BaseDropDown
						v-model="localRule"
						:options="CUSTOMER_CONDITION_RULE_OPTIONS"
						:searchable="false"
						:allow-empty="false"
						class="select-custom"
						label="label"
						track-by="value"
						label-drop-down="Rule"
						@input="handleRuleChange"
					/>
				</CCol>
				<CCol md="9" class="pl-1">
					<label>Email</label>
					<div class="d-flex align-items-start">
						<CInput
							v-model.trim="inputEmail"
							:is-valid="isValid && null"
							:label="label"
							:placeholder="placeholder"
							:description="$t('global.separateBySemicolon')"
							:invalid-feedback="$t('global.error.invalid')"
							class="flex-fill"
							add-input-classes="form-get-email-input"
							data-test-id="input-email"
						/>
						<CButton
							:disabled="!isValid"
							type="submit"
							class="btn-add ml-3"
							color="secondary"
							data-test-id="button-add"
						>
							Add
						</CButton>
					</div>
				</CCol>
			</CRow>
		</CForm>
		<slot v-if="!emailList.length" name="no-item">
		</slot>
		<ul
			v-else
			class="list-item"
			:class="{ 'show-border': hasBorder }"
		>
			<h6 class="typo-body-2">
				Email
			</h6>
			<p class="show-text">
				{{ showText }}
			</p>
		</ul>
	</div>
</template>

<script>
import { multipleEmailFormat } from '../assets/js/validators';
import { CONDITION_RULE_KEYS, CUSTOMER_CONDITION_RULE_OPTIONS } from '../enums/promotions';

export default {
	name: 'FormGetEmail',
	validations() {
		let schema = {
			inputEmail: {},
		};
		if (this.localRule && this.localRule.value === CONDITION_RULE_KEYS.IS) {
			schema = {
				inputEmail: {
					format: multipleEmailFormat,
				},
			};
		}
		return schema;
	},
	props: {
		label: {
			type: String,
			default: null,
		},
		rule: {
			type: String,
			default: null,
		},
		emailList: {
			type: Array,
			default: () => [],
		},
		hasBorder: {
			type: Boolean,
			default: false,
		},
		placeholder: {
			type: String,
			default: 'Paste or type email here',
		},
	},
	data() {
		return {
			CUSTOMER_CONDITION_RULE_OPTIONS,
			inputEmail: '',
			localRule: null,
		};
	},
	computed: {
		isValid() {
			if (!this.inputEmail) {
				return true;
			}

			return !this.$v.inputEmail.$error;
		},
		showText() {
			return this.emailList.join('; ');
		},
	},
	methods: {
		resetState() {
			this.inputEmail = '';
			this.localRule = this.rule ? CUSTOMER_CONDITION_RULE_OPTIONS.find((rule) => rule.value === this.rule) : CUSTOMER_CONDITION_RULE_OPTIONS[0];
			this.$v.$reset();
		},
		getListFromInput(input) {
			let list = input.split(';');

			// trim all items and remove null
			list = list.map((item) => item.trim()).filter((item) => item);

			// remove duplicates
			return [...new Set(list)];
		},
		handleRuleChange() {
			this.$emit('onGetEmail', { rule: this.localRule.value, list: this.emailList });
		},
		handleSubmit() {
			if (!this.inputEmail) {
				return;
			}

			this.$v.$touch();

			if (this.$v.$invalid) {
				return;
			}

			const mergedInput = `${this.showText}; ${this.inputEmail}`;
			const list = this.getListFromInput(mergedInput);
			this.$emit('onGetEmail', { rule: this.localRule.value, list });
			this.resetState();
		},
	},
};
</script>

<style lang="scss" scoped>
	::v-deep .input-group-text {
		padding-right: 0;
	}

	::v-deep .form-get-email-input {
		margin-right: rem(100);
	}

	.btn-add {
		min-width: rem(84);
	}

	.list-item {
		padding: rem(20) rem(16) 0;
		max-height: rem(320);
		overflow: auto;
	}

	.show-text {
		font-size: rem($font-size-caption);
		font-weight: $font-weight-semi-bold;
		color: $color-black-45;
	}

	.show-border {
		border: solid 1px $color-gray-400;
		border-radius: rem(4);
	}
</style>
